import { render, staticRenderFns } from "./ImageSegmentationPreviewModal.vue?vue&type=template&id=a77cba7a&scoped=true"
import script from "./ImageSegmentationPreviewModal.vue?vue&type=script&lang=js"
export * from "./ImageSegmentationPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ImageSegmentationPreviewModal.vue?vue&type=style&index=0&id=a77cba7a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77cba7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a77cba7a')) {
      api.createRecord('a77cba7a', component.options)
    } else {
      api.reload('a77cba7a', component.options)
    }
    module.hot.accept("./ImageSegmentationPreviewModal.vue?vue&type=template&id=a77cba7a&scoped=true", function () {
      api.rerender('a77cba7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/ImageSegmentationPreviewModal.vue"
export default component.exports